export const QUERY_KEY_PROMPTS = 'Prompts'
export const QUERY_KEY_PROMPTS_BY_SLUG = 'PromptsBySlug'
